import { 
  SET_SELECTED_ITEM,
  SET_RELATIONS,
  SET_SOURCES,
  SET_TABLES,
  SET_COLUMNS_LOADING,
  SET_COLUMNS,
  SET_SOURCE_TABLES,
  SET_SOURCE_TABLES_LOADING,
  SET_ENTITY_RELATIONS,
  SET_ENTITY_RELATIONS_LOADING,
} from './mutation-types';

export default {
  [SET_SELECTED_ITEM](state, payload) {
    state.selectedItem = payload.item;
    state.selectedType = payload.type;
  },
  [SET_RELATIONS](state, relations) {
    state.relations = relations;
  },
  [SET_SOURCES](state, sources) {
    state.sources = sources;
  },
  [SET_TABLES](state, tables) {
    state.tables = tables;
  },
  [SET_COLUMNS_LOADING](state, loading) {
    state.columnsLoading = loading;
  },
  [SET_COLUMNS](state, columns) {
    state.columns = columns;
  },
  [SET_SOURCE_TABLES](state, payload) {
    state.sourceTables = payload;
  },
  [SET_SOURCE_TABLES_LOADING](state, loading) {
    state.sourceTablesLoading = loading;
  },
  [SET_ENTITY_RELATIONS_LOADING](state, loading) {
    state.entityRelationsLoading = loading;
  },
  [SET_ENTITY_RELATIONS](state, payload) {
    state.entityRelations = payload;
  },
};